module.exports = __webpack_public_path__ + "img/about_qr.a68f8417.jpg";